import { createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/express-area.jpg'
import _imports_1 from '@/assets/images/express-second-area.jpg'

const _withId = /*#__PURE__*/_withScopeId("data-v-53768a86")

_pushScopeId("data-v-53768a86")
const _hoisted_1 = { class: "ExpressAreaLimit" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h2", { class: "ExpressAreaLimit__title" }, "Внимание!", -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("p", { style: {"margin-top":"12px"} }, [
  /*#__PURE__*/_createVNode("u", null, " Вес груза должен быть не более 20кг и должен помещаться в багажник легкового авто. ")
], -1)
const _hoisted_4 = { class: "ExpressAreaLimit__content" }
const _hoisted_5 = /*#__PURE__*/_createVNode("p", null, "Имеются ограничения по зоне доставки", -1)
const _hoisted_6 = {
  class: "ExpressAreaLimit__img",
  src: _imports_0
}
const _hoisted_7 = {
  class: "ExpressAreaLimit__img",
  style: {"margin-left":"16px"},
  src: _imports_1
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode("div", _hoisted_4, [
      _hoisted_5,
      _createVNode("span", {
        class: "content__trigger",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.trigger && _ctx.trigger(...args)))
      }, "Подробнее")
    ]),
    _withDirectives(_createVNode("img", _hoisted_6, null, 512), [
      [_vShow, _ctx.is_image_showed]
    ]),
    _withDirectives(_createVNode("img", _hoisted_7, null, 512), [
      [_vShow, _ctx.is_image_showed]
    ])
  ]))
})